export default __webpack_public_path__ + "static/media/movieapp.077b103a.png";